import { Col, Row } from 'antd';
import * as React from 'react';

type Props = {}

const PasswordResetExpiredCard: React.FC<Props> = ({ }) => {

    return (<>
        <Row justify="center">
            <Col>
                <p>Your reset password token has already expired. Please request a new token from your admin.</p>
                <a href="/signin">Click here to go to signin page</a>
            </Col>
        </Row>
    </>
    );
}

export default PasswordResetExpiredCard;
